<template>
    <div :class="['flex-col gap-4 bg-white p-4 flex flex-col justify-between border', customClass]">
      <div class="header">
        <p class="text-primary-900 text-sm">
          {{ title }}
        </p>
      </div>
      <div class="content">
        <div class="flex flex-row justify-between align-center">
          <div class="flex flex-col gap-2">
            <p class="text-primary-900 xl:text-md 2xl:text-xl">{{ count || 0 }}</p>
            <p v-if="subtitle" class="text-primary-900 text-sm">
              {{ subtitle }}
            </p>
          </div>
          <v-icon class="text-primary-900 text-xl">{{ icon }}</v-icon>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'InfoCard',
    props: {
      customClass: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        required: true
      },
      count: {
        type: [String, Number],
        required: true
      },
      icon: {
        type: String,
        default: 'mdi-phone-outline'
      }
    }
  }
  </script>